/**
 * Configuración SOLO para vehículos comunes
 * Todo lo que no esté aquí cae en "adicional"
 */
const VEHICULOS_COMUNES_CONFIG = {
    1: {
        icono: 'pi-car',
        descripcion: 'Ideal para grupos pequeños',
    },
    2: {
        icono: 'pi-truck',
        descripcion: 'Comodidad media',
    },
    3: {
        icono: 'pi-building',
        descripcion: 'Ideal para grupos grandes',
    },
    6: {
        icono: 'pi-truck',
        descripcion: 'Ideal para grupos medianos',
    },
};

/**
 * Configuración default para vehículos no conocidos
 */
const DEFAULT_ADICIONAL_CONFIG = {
    icono: 'pi-truck',
};

/**
 * Mapper backend → UI
 *
 * @param {Array<{ID:number, TIPO:string, CAPACIDAD_PASAJEROS:number}>} unidades
 * @returns {{ vehiculosComunes: Array, vehiculosAdicionales: Array }}
 */
export function mapVehiculosParaUI(unidades = []) {
    const vehiculosComunes = [];
    const vehiculosAdicionales = [];

    unidades.forEach((unidad) => {
        const esComun = Boolean(VEHICULOS_COMUNES_CONFIG[unidad.ID]);

        const config = esComun
            ? VEHICULOS_COMUNES_CONFIG[unidad.ID]
            : DEFAULT_ADICIONAL_CONFIG;

        const vehiculoUI = {
            nombre: unidad.TIPO,
            valor: unidad.ID,
            icono: config.icono,
            capacidad: `${unidad.CAPACIDAD_PASAJEROS} pasajeros`,
            ...(config.descripcion && { descripcion: config.descripcion }),
        };

        if (esComun) {
            vehiculosComunes.push(vehiculoUI);
        } else {
            vehiculosAdicionales.push(vehiculoUI);
        }
    });

    return {
        vehiculosComunes,
        vehiculosAdicionales,
    };
}
